import { CIcon } from '~/icons/types'
export const ciAudit: CIcon = {
  width: 24,
  height: 24,
  paths: [
    {
      d:
        'M12.397 12.865a.749.749 0 0 0-1.034.238l-1.939 3.103-1.339-1.674a.752.752 0 0 0-1.054-.117.752.752 0 0 0-.117 1.055l2 2.5a.752.752 0 0 0 .586.28h.043a.754.754 0 0 0 .593-.352l2.5-4a.75.75 0 0 0-.239-1.033Z'
    },
    {
      d:
        'M18.336 3.169a37.252 37.252 0 0 0-.672-.051A2.982 2.982 0 0 0 15 1.5h-1.5a2.98 2.98 0 0 0-2.664 1.618 73.14 73.14 0 0 0-.672.051C8.646 3.295 7.5 4.559 7.5 6.108V7.5H4.875A1.877 1.877 0 0 0 3 9.375v11.25c0 1.034.841 1.875 1.875 1.875h9.75a1.877 1.877 0 0 0 1.875-1.875V19.5H18c1.654 0 3-1.346 3-3V6.108c0-1.549-1.146-2.813-2.664-2.939Zm-6.274.903A1.49 1.49 0 0 1 13.5 3H15a1.494 1.494 0 0 1 1.5 1.5H12c0-.147.021-.291.062-.428ZM15 20.625a.375.375 0 0 1-.375.375h-9.75a.375.375 0 0 1-.375-.375V9.375c0-.207.168-.375.375-.375h9.75c.207 0 .375.168.375.375v11.25Zm4.5-4.125c0 .827-.673 1.5-1.5 1.5h-1.5V9.375A1.877 1.877 0 0 0 14.625 7.5H9V6.108c0-.763.554-1.384 1.289-1.444l.218-.018A1.502 1.502 0 0 0 12 6h4.5c.777 0 1.419-.595 1.493-1.354l.219.018c.734.061 1.288.682 1.288 1.444V16.5Z'
    }
  ],
  name: 'audit',
  type: 'light'
}
